import { useState } from 'react';
import { 
  Burger, 
  Drawer, 
  Stack, 
  Text, 
  Button, 
  Group, 
  Divider 
} from '@mantine/core';
import { IconInfoCircle, IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from '../../contexts/hooks';
import { LanguageSelector } from './LanguageSelector';
import { SocialShare } from './SocialShare';

interface MobileMenuProps {
  pdfFile?: File | null;
  isTopSectionExpanded: boolean;
  onToggleTopSection: () => void;
}

export function MobileMenu({ pdfFile, isTopSectionExpanded, onToggleTopSection }: MobileMenuProps) {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Burger
        opened={opened}
        onClick={() => setOpened(!opened)}
        size="sm"
        color="blue"
      />
      
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        position="right"
        size="xs"
        padding="md"
      >
        <Stack gap="md">
          {/* Language and Social */}
          <Group justify="space-between">
            <LanguageSelector />
            <SocialShare size="sm" />
          </Group>
          
          <Divider />
          
          {/* Instructions Toggle */}
          {pdfFile && (
            <Button
              variant="light"
              fullWidth
              leftSection={
                isTopSectionExpanded ? (
                  <IconChevronUp size={16} />
                ) : (
                  <IconChevronDown size={16} />
                )
              }
              onClick={() => {
                onToggleTopSection();
                setOpened(false);
              }}
            >
              {isTopSectionExpanded ? t('editor.instructions.hide') : t('editor.instructions.show')}
            </Button>
          )}
          
          {/* Instructions Content */}
          <Stack gap="sm">
            <Group gap="xs">
              <IconInfoCircle size={16} />
              <Text size="sm" fw={500}>
                {t('editor.instructions')}
              </Text>
            </Group>
            
            <Stack gap="xs">
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ 
                  minWidth: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: 'var(--mantine-color-blue-6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '8px',
                  marginTop: '1px'
                }}>
                  1
                </div>
                <Text size="xs">{t('editor.instructions.step1')}</Text>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ 
                  minWidth: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: 'var(--mantine-color-blue-6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '8px',
                  marginTop: '1px'
                }}>
                  2
                </div>
                <Text size="xs">{t('editor.instructions.step2')}</Text>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ 
                  minWidth: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: 'var(--mantine-color-blue-6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '8px',
                  marginTop: '1px'
                }}>
                  3
                </div>
                <Text size="xs">{t('editor.instructions.step3')}</Text>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ 
                  minWidth: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: 'var(--mantine-color-blue-6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '8px',
                  marginTop: '1px'
                }}>
                  4
                </div>
                <Text size="xs">{t('editor.instructions.step4')}</Text>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ 
                  minWidth: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: 'var(--mantine-color-blue-6)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '8px',
                  marginTop: '1px'
                }}>
                  5
                </div>
                <Text size="xs">{t('editor.instructions.step5')}</Text>
              </div>
            </Stack>
          </Stack>
        </Stack>
      </Drawer>
    </>
  );
}